"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var core=require("@material-ui/core"),t$1=require("@material-ui/core/Portal"),r=require("prop-types"),t=require("react"),a=require("styled-components"),theme=require("../../styles/theme.js"),close=require("../../images/close.svg.js");function _interopDefaultLegacy(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t__default$1=_interopDefaultLegacy(t$1),r__default=_interopDefaultLegacy(r),t__default=_interopDefaultLegacy(t),a__default=_interopDefaultLegacy(a);let s=a__default.default.div`
  display: flex;
  align-items: center;
`,m={blue:"var(--ds-color-brand-50, #eef2ff)",red:"var(--ds-color-rose-100, #ffe4e6)"},u=a__default.default.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: ${e=>m[e.color]||e.color};
`;const HeaderIcon=({Icon:e,color:l})=>t__default.default.createElement(u,{color:l},"function"==typeof e?t__default.default.createElement(e,{color:"red"===l&&theme.theme.palette.error.main}):t__default.default.createElement("img",{alt:"",role:"presentation",src:e}));HeaderIcon.propTypes={Icon:r__default.default.oneOfType([r__default.default.func,r__default.default.string]),color:r__default.default.string};let f=a__default.default.button.attrs({children:t__default.default.createElement("img",{alt:"close-button",src:close.default})})`
  padding: 10px;
  border: none;
  background: none;
  cursor: pointer;
`;const ModalTitle=({children:e,id:l})=>t__default.default.createElement(core.Typography,{display:"inline",id:l,style:{color:theme.theme.palette.common.gray800,marginRight:"10px"},variant:"subtitle2"},e);ModalTitle.propTypes={children:r__default.default.oneOfType([r__default.default.arrayOf(r__default.default.node),r__default.default.node]),id:r__default.default.string},ModalTitle.defaultProps={id:null};let g=a__default.default.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${theme.theme.customBorders.gray200};
  padding: ${theme.theme.misc.marginMobile}px ${theme.theme.misc.marginDesktop}px;
`;const ModalHeader=({children:e,onClose:l})=>t__default.default.createElement(g,null,t__default.default.createElement(s,null,e),t__default.default.createElement(f,{onClick:l}));ModalHeader.propTypes={children:r__default.default.oneOfType([r__default.default.arrayOf(r__default.default.node),r__default.default.node]),onClose:r__default.default.func};const InnerContent=a__default.default.div`
  padding: ${theme.theme.misc.marginDesktop}px;
  overflow-y: auto;
  ${({height:e})=>e&&a.css`
      height: ${e};
    `}
`;let x=a__default.default.div`
  background-color: ${theme.theme.palette.common.gray100};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 16px ${theme.theme.misc.marginDesktop}px;
`;const ModalFooter=({children:e})=>t__default.default.createElement(x,null,e);ModalFooter.propTypes={children:r__default.default.oneOfType([r__default.default.arrayOf(r__default.default.node),r__default.default.node])};let y=a__default.default.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: ${e=>e.blurOverlay&&"blur(6px)"};
  background-color: ${e=>e.blurOverlay?"rgb(19, 30, 64, 0.6)":"rgba(0, 0, 0, 0.5)"};
  z-index: ${theme.theme.zIndex.modal};
  padding: ${e=>!e.fullScreenOnMobile&&`${theme.theme.misc.marginMobile}px`};
`,b=a__default.default.div`
  position: relative;
  margin: auto;
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 64px);
  width: ${e=>e.maxWidth?`${"string"==typeof e.maxWidth?e.maxWidth:`${e.maxWidth}px`}`:"636px"};
  max-width: 100%;
  z-index: ${theme.theme.zIndex.modal};
  background-color: ${theme.theme.palette.common.white};
  border: ${theme.theme.customBorders.gray200};
  border-radius: ${theme.theme.misc.borderRadius}px;

  ${({height:e})=>e&&a.css`
      height: ${e};
      max-height: ${e};
    `}

  @media (max-width: ${theme.theme.misc.mobileBreakpoint}px) {
  ${g}, ${x} {
    padding: ${theme.theme.spacing(1.5,3)};
  }
  ${x} {
    justify-content: ${e=>e.fullScreenOnMobile&&"center"};
  }
    ${InnerContent} {
      flex: 1;
      padding: ${theme.theme.spacing(3)}px;
    }
    ${e=>e.fullScreenOnMobile&&a.css`
        margin: 0;
        max-height: none;
        height: 100%;
        border-radius: 0;

        ${u} {
          display: none;
        }
      `}
`,h='a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';function $({children:e,onClose:l,fullScreenOnMobile:d=!0,maxWidth:n,height:o=null,blurOverlay:c,ariaLabelledBy:_=null}){let p=t.useRef(null),v=t.useRef(null),M=t.useCallback(e=>{p.current=e,e&&!v.current&&(v.current=document.activeElement,(e.querySelector(h)||e).focus())},[]),O=t.useCallback(e=>{if("Escape"===e.key){e.stopPropagation(),e.preventDefault(),l();return}if("Tab"===e.key&&p.current){let l=p.current.querySelectorAll(h);if(0===l.length)return;let d=l[0],n=l[l.length-1];e.shiftKey&&document.activeElement===d?(e.preventDefault(),n.focus()):e.shiftKey||document.activeElement!==n||(e.preventDefault(),d.focus())}},[l]);return t.useEffect(()=>()=>{var e,l;null==(l=v.current)||null==(e=l.focus)||e.call(l)},[]),t.useEffect(()=>(document.addEventListener("keydown",O,!0),()=>{document.removeEventListener("keydown",O,!0)}),[O]),t__default.default.createElement(t__default$1.default,null,t__default.default.createElement(y,{blurOverlay:c,fullScreenOnMobile:d,onClick:l},t__default.default.createElement(b,{ref:M,"aria-labelledby":_,"aria-modal":"true",role:"dialog",tabIndex:-1,fullScreenOnMobile:d,height:o,maxWidth:n,onClick:e=>e.stopPropagation()},e)))}$.propTypes={ariaLabelledBy:r__default.default.string,blurOverlay:r__default.default.bool,children:r__default.default.oneOfType([r__default.default.arrayOf(r__default.default.node),r__default.default.node]),fullScreenOnMobile:r__default.default.bool,height:r__default.default.string,maxWidth:r__default.default.oneOfType([r__default.default.string,r__default.default.number]),onClose:r__default.default.func};var i=a__default.default($)``;exports.HeaderIcon=HeaderIcon,exports.InnerContent=InnerContent,exports.ModalFooter=ModalFooter,exports.ModalHeader=ModalHeader,exports.ModalTitle=ModalTitle,exports.default=i;
//# sourceMappingURL=index.js.map
